var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarMulti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#646A82;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.2,19.6c-0.4,0-0.8-0.2-1.1-0.5c-0.3-0.3-0.5-0.7-0.5-1.1V7.6c0-0.2,0.1-0.4,0.2-0.6C2,6.9,2.2,6.8,2.4,6.8 C2.6,6.8,2.8,6.9,3,7c0.2,0.2,0.2,0.3,0.2,0.6V18h10.4c0.2,0,0.4,0.1,0.6,0.2c0.1,0.2,0.2,0.3,0.2,0.6c0,0.2-0.1,0.4-0.2,0.6 c-0.2,0.2-0.3,0.2-0.6,0.2H3.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.2,12.4c-0.6,0-1-0.2-1.4-0.6c-0.4-0.4-0.6-0.9-0.6-1.4c0-0.6,0.2-1,0.6-1.4c0.4-0.4,0.9-0.6,1.4-0.6 c0.6,0,1,0.2,1.4,0.6c0.4,0.4,0.6,0.9,0.6,1.4c0,0.6-0.2,1-0.6,1.4C10.2,12.2,9.8,12.4,9.2,12.4z M6,16.8c-0.4,0-0.8-0.2-1.1-0.5 c-0.3-0.3-0.5-0.7-0.5-1.1V4c0-0.4,0.2-0.8,0.5-1.1C5.2,2.6,5.6,2.4,6,2.4h0.8V1.6C6.8,1.4,6.9,1.2,7,1c0.2-0.2,0.3-0.2,0.6-0.2 C7.8,0.8,8,0.9,8.2,1c0.2,0.2,0.2,0.3,0.2,0.6v0.8h6.4V1.6c0-0.2,0.1-0.4,0.2-0.6c0.2-0.2,0.3-0.2,0.6-0.2c0.2,0,0.4,0.1,0.6,0.2 c0.2,0.2,0.2,0.3,0.2,0.6v0.8h0.8c0.4,0,0.8,0.2,1.1,0.5c0.3,0.3,0.5,0.7,0.5,1.1v11.2c0,0.4-0.2,0.8-0.5,1.1 c-0.3,0.3-0.7,0.5-1.1,0.5H6z M6,15.2h11.2v-8H6V15.2z M6,5.6h11.2V4H6V5.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarMulti);
export default __webpack_public_path__ + "static/media/Calendar-Multi.3c05bb478c07f09664a8858d9172a450.svg";
export { ForwardRef as ReactComponent };